import { atom } from 'jotai'

export const isDrawerOpen = atom(false)
